import {AfterViewInit, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {OrganizationService} from "../../../_service/organization.service";
import {Title} from "@angular/platform-browser";
import {HttpService} from "../../../_service/http.service";
import {Metrika} from "ng-yandex-metrika";
import "rxjs/add/operator/filter";
import {isNullOrUndefined} from "util";
import {ViewSettingService} from "../../../main-page/view-setting-service/view-setting.service";

@Component({
  templateUrl: 'widget-status.component.html',
  styleUrls: ['../../bootstrap.css', '../../styles.css', '../academ-widget/color-scheme.css'],
  encapsulation: ViewEncapsulation.None
})
export class WidgetStatusComponent implements OnInit, AfterViewInit {
  public fail = 'FAIL';
  public success = 'SUCCESS';
  public status: string;
  public action: string;
  public siteRedirect: string;
  private alias;
  private ukName;
  private checkNumber;
  public checkData: any[];
  cssName: any;


  ngOnInit(): void {
    this.route.data.subscribe(v => {
      this.status = v.status;
      this.action = v.action;
      const sb = [];
      sb.push('rest/');
      sb.push(this.alias);
      sb.push('/gerRedirectLink?');
      sb.push('&status=');
      sb.push(this.status);
      this.httpService.getData(sb.join('')).then(data => {
          this.siteRedirect = data._body;
          console.log(data);
        },
        error => {
          console.log('Error in get account state: ', error);
        });

      if (this.status == this.success &&
        !isNullOrUndefined(this.route.snapshot.queryParams.hash) &&
        !isNullOrUndefined(this.route.snapshot.queryParams.orderId)
      ) {
        const sb2 = [];
        sb2.push('rest/');
        sb2.push(this.alias);
        sb2.push('/getCheck?');
        sb2.push('&hash=');
        sb2.push(this.route.snapshot.queryParams.hash);
        sb2.push('&orderId=');
        sb2.push(this.route.snapshot.queryParams.orderId);

        this.httpService.getData(sb2.join('')).then(data => {

            this.checkData = [];

            console.log(data);
            for (const s of data.checkDto.dataDto.stringArrayList) {
              const splitted = s.split(':');
              const stringHead = splitted.shift();
              const stringBody = splitted.join(':');

              if (stringHead === 'Номер платежа') {
                this.checkNumber = stringBody;
              }

              this.checkData.push(
                {
                  'head': stringHead,
                  'body': stringBody
                }
              )
              ;

            }

          },
          error => {
            console.log('Error in get account state: ', error);
          });
      }
    }).unsubscribe();


  }

  constructor(public viewSettingService: ViewSettingService,
              private route: ActivatedRoute,
              private organizationService: OrganizationService,
              private titleService: Title,
              private httpService: HttpService,
              private metrika: Metrika,
              private router: Router) {
    this.alias = this.route.snapshot.params.alias;
    this.titleService.setTitle('Лёгкий Платёж ЖКХ');
  }

  redirectToWidget() {
    window.location.href = this.siteRedirect;
  }

  redirectToSite() {
    window.location.href = this.siteRedirect;
  }

  close() {
    window.close();
  }

  ngAfterViewInit() {
    console.log('Metrika init');
    let prevPath = this.router.url;
    // this.metrika.;
    this.router
      .events
      .filter(event => (event instanceof NavigationEnd))
      .subscribe(() => {
        const newPath = this.router.url;
        this.metrika.hit(newPath, {
          referer: prevPath,
        });
        console.log('Metrika init');
        prevPath = newPath;
      });
  }

  // onload="window.print();window.close()"
  print(): void {
    let printContents, popupWin, checkNumber, ukNameLabel;
    checkNumber = this.checkNumber;
    // ukNameLabel = this.ukName;

    ukNameLabel = '&laquo;UCS Cards&raquo;';

    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`<html>
<head>
  <title>Print tab</title>
  <link rel="stylesheet" type="text/css" href="/css/bootstrap.css">
</head>
<body onload="window.print();window.close()">
<div class="col-10 col-md-10 col-lg-8 mt-5" style="margin: auto">
  <h4>Чек №${checkNumber}</h4>
  <div>${printContents}</div>
  <div class="p-3" style="min-width: 200px; max-width: 500px; float: left;
  border: solid; border-width: medium; color: #0275d8;
  border-color: #0275d8">
    <h5 style="display:inline-block;">Операция выполнена</h5><br/>
    <h5 style="display:inline-block;">${ukNameLabel}</h5>
  </div>
</div>
</body>
</html>`
    );
    popupWin.document.close();
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/payment-widget/widgetStatus/widget-status.component.ts